import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import { SelectField } from 'Common/SemanticWrapper';
import AssignItemsForm from './AssignItemsForm';
import connect from 'react-redux/es/connect/connect';
import _ from 'lodash';
import { resetForm } from 'State/forms/actions';
import { ASSIGN_ITEMS_FORM_NAME } from 'Common/FormEnum';
import { BidGroupEnum as BidFieldEnum, FilterEnum } from 'Common/FieldEnum';
import {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAcctCategoryForCurrentSite,
  getVendorForCurrentSite,
  getStorageLocationForCurrentSite,
  updateAssignItemData,
  checkAllAction,
  saveOrderingItems,
  clearSubmitError,
} from '../state/assignItems/actions';
import { LoadingModal } from '../../../components';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { makeOptionsData } from 'Common/FormHelper';

class AssignItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValues: {
        [FilterEnum.GroupId_Bid]: 0,
        [FilterEnum.GroupId_Cat]: 0,
        [FilterEnum.GroupId_Item]: 0,
        [FilterEnum.VendorId]: 0,
      },
    };
  }
  componentDidUpdate(prevProps) {
    const { clearSubmitError } = this.props;

    if (
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError') ||
      errorToast(this.props, prevProps, 'storageLocationDataError') ||
      errorToast(this.props, prevProps, 'assignItemsDataError') ||
      errorToast(this.props, prevProps, 'saveOrderingItemsError')
    ) {
      clearSubmitError();
    } else if (this.props.isSubmitting && !prevProps.isSubmitting) {
      createToast(
        toastType.success,
        'Success',
        'Items assigned successfully',
        true
      );
      clearSubmitError();
    }
  }
  componentDidMount() {
    this.props.getBidGroupForCurrentSite(BidFieldEnum.AllOnly);
    this.props.getItemGroupForCurrentSite();
    this.props.getAcctCategoryForCurrentSite();
    this.props.getVendorForCurrentSite();
    this.props.getStorageLocationForCurrentSite();
  }
  saveOrderingItems = (e, modalData, modifiedItemsData) => {
    this.props.saveOrderingItems(modalData, modifiedItemsData);
    this.props.handleAssignItemsModal();
  };
  handleChange = (e, values) => {
    this.setState({ filterValues: values });
  };

  clearFilters = () => {
    this.setState({
      filterValues: {
        [FilterEnum.GroupId_Bid]: 0,
        [FilterEnum.GroupId_Cat]: 0,
        [FilterEnum.GroupId_Item]: 0,
        [FilterEnum.VendorId]: 0,
      },
    });
    this.props.resetForm(ASSIGN_ITEMS_FORM_NAME);
  };

  onAssignItemsModalClose = () => {
    this.setState({
      filterValues: {
        [FilterEnum.GroupId_Bid]: 0,
        [FilterEnum.GroupId_Cat]: 0,
        [FilterEnum.GroupId_Item]: 0,
        [FilterEnum.VendorId]: 0,
      },
    });
    this.props.onAssignItemsClose();
  };
  render() {
    const {
      modalData,
      showAssignItemsModal,
      loading,
      isSubmitting,
      assignItemsData,
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      assignItemsAcctCategoryData,
      assignItemsVendorData,
      updateAssignItemData,
      checkAllAction,
    } = this.props;

    const bidGroupOptions = makeOptionsData(assignItemsBidGroupData);
    const itemGroupOptions = makeOptionsData(assignItemsItemGroupData);
    const acctCategoryOptions = makeOptionsData(assignItemsAcctCategoryData);
    const vendorData = makeOptionsData(assignItemsVendorData);

    const fields = [
      {
        name: FilterEnum.GroupId_Bid,
        component: SelectField,
        type: 'text',
        options: bidGroupOptions,
        label: 'Bid Group',
      },
      {
        name: FilterEnum.GroupId_Item,
        component: SelectField,
        type: 'text',
        options: itemGroupOptions,
        label: 'Item Group',
      },
      {
        name: FilterEnum.GroupId_Cat,
        component: SelectField,
        type: 'text',
        options: acctCategoryOptions,
        label: 'Acct. Category',
      },
      {
        name: FilterEnum.VendorId,
        component: SelectField,
        type: 'text',
        options: vendorData,
        label: 'Distributor',
      },
    ];
    const filterValues = {};
    _.map(this.state.filterValues, function(value, key, items) {
      if (items[key] !== 0) {
        filterValues[key] = items[key];
      }
    });
    const newData =
      Object.keys(filterValues).length > 0
        ? _.filter(assignItemsData, filterValues)
        : assignItemsData;

    return (
      <div>
        <Modal
          size={'large'}
          open={showAssignItemsModal}
          closeOnRootNodeClick={false}
          closeIcon
          onClose={this.onAssignItemsModalClose}
        >
          {loading && <LoadingModal />}
          <Header
            icon="cart plus"
            content={`Assign items for Site: ${modalData.Id} ${
              modalData.Description
            }`}
          />
          <Modal.Content scrolling>
            <AssignItemsForm
              initialValues={{
                ...this.state.filterValues,
              }}
              loading={loading}
              assignItemsData={newData}
              updateAssignItemData={updateAssignItemData}
              checkAllAction={checkAllAction}
              modalData={modalData}
              fields={fields}
              handleChange={this.handleChange}
              filterValues={filterValues}
              clearFilters={this.clearFilters}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              loading={isSubmitting}
              positive
              inverted
              color="orange"
              size="big"
              content="Save"
              disabled={isSubmitting}
              onClick={e => {
                const modifiedItemsData = _.filter(assignItemsData, data => {
                  return data.dirty;
                });
                this.saveOrderingItems(e, modalData, modifiedItemsData);
              }}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ SiteSetupState: { assignItems } }) => {
  return {
    assignItemsData: assignItems.assignItemsData,
    loading: assignItems.loading,
    isSubmitting: assignItems.isSubmitting,
    assignItemsBidGroupData: assignItems.bidGroupData,
    assignItemsItemGroupData: assignItems.itemGroupData,
    assignItemsAcctCategoryData: assignItems.acctCategoryData,
    assignItemsVendorData: assignItems.vendorData,
    bidGroupDataError: assignItems.bidGroupDataError,
    itemGroupDataError: assignItems.itemGroupDataError,
    acctCategoryDataError: assignItems.acctCategoryDataError,
    vendorDataError: assignItems.vendorDataError,
    storageLocationDataError: assignItems.storageLocationDataError,
    assignItemsDataError: assignItems.assignItemsDataError,
    saveOrderingItemsError: assignItems.saveOrderingItemsError,
  };
};

export const AssignItemsModal = connect(
  mapStateToProps,
  {
    getBidGroupForCurrentSite,
    getItemGroupForCurrentSite,
    getAcctCategoryForCurrentSite,
    getVendorForCurrentSite,
    getStorageLocationForCurrentSite,
    updateAssignItemData,
    checkAllAction,
    saveOrderingItems,
    clearSubmitError,
    resetForm,
  }
)(AssignItems);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/components/AssignItemsModal.js